import { agentFilterOptions } from '../../constants/app.constants';
import { agentActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  agents: {
    data: {},
    message: '',
  },
  agentDeleteData: {
    data: null,
    message: '',
  },
  filter: {
    [agentFilterOptions.User]: [],
    [agentFilterOptions.Status]: [],
  },
  error: '',
};

const AgentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.AGENT_SET_BOT_ERROR:
      let { id: agentId, isError } = action.payload;
      let updatedAgents = state.agents.data.rows.map((a) => {
        if (a.id == agentId) return { ...a, isError };
        else return { ...a };
      });
      return {
        ...state,
        agents: {
          ...state.agents,
          data: {
            ...state.agents.data,
            rows: [...updatedAgents],
          },
        },
      };
    case ACTION.AGENT_FILTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ACTION.AGENT_FILTER_SUCCESS:
      const { key, values } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          [key]: [...values],
        },
      };
    case ACTION.AGENT_FILTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.AGENT_START_FETCH:
      return {
        ...state,
        loading: true,
      };

    case ACTION.AGENT_SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ACTION.AGENT_REMOVE_ERROR:
      return {
        ...state,
        error: '',
      };

    case ACTION.FETCH_AGENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        agents: {
          ...state.agents,
          data: action.payload,
          message: '',
        },
        error: '',
      };

    case ACTION.FETCH_AGENTS_FAILURE:
      return {
        ...state,
        loading: false,
        agents: {
          ...state.agents,
          data: {},
        },
        error: action.payload,
      };

    case ACTION.REMOVE_FETCH_AGENTS:
      return {
        ...state,
        loading: false,
        agents: {
          ...state.agents,
          data: {},
          message: '',
        },
        error: '',
      };

    case ACTION.UPDATE_AGENT_STATUS:
      return {
        ...state,
        loading: false,
        agents: {
          ...state.agents,
          data: {
            ...state.agents.data,
            rows: state.agents.data.rows.map((agent) => {
              if (agent.id === action.payload.id) {
                return {
                  ...agent,
                  status: action.payload.status,
                  updatedAt: action.payload.updatedAt,
                  User: action.payload.User,
                };
              }
              return agent;
            }),
          },
        },
        error: '',
      };

    case ACTION.UPDATE_AGENT_STATUS_ARRAY:
      return {
        ...state,
        loading: false,
        agents: {
          ...state.agents,
          data: {
            ...state.agents.data,
            rows: state.agents.data.rows.map((agent) => {
              action.payload.data.forEach((item) => {
                if (item.id === agent.id) {
                  agent = {
                    ...agent,
                    status: action.payload.status,
                    updatedAt: item.updatedAt,
                  };
                }
              });
              return agent;
            }),
          },
        },
        error: '',
      };

    case ACTION.UPDATE_AGENT_IS_BUSY_STATUS:
      return {
        ...state,
        loading: false,
        agents: {
          ...state.agents,
          data: {
            ...state.agents.data,
            rows: state.agents.data.rows.map((agent) => {
              if (agent.id === action.payload.id) {
                return { ...agent, isBusy: action.payload.isBusy };
              }
              return agent;
            }),
          },
        },
        error: '',
      };
    case ACTION.DELETE_AGENT_SUCCESS:
      const { data, message } = action.payload;
      return {
        ...state,
        loading: false,
        agentDeleteData: {
          ...state.agentDeleteData,
          data: data,
          message: message,
        },
      };
    case ACTION.DELETE_AGENT_FAILURE:
      return {
        ...state,
        loading: false,
        agentDeleteData: {
          ...state.agentDeleteData,
        },
        error: action.payload,
      };
    case ACTION.REMOVE_AGENT_DELETE_SUCCESS_MESSAGE:
      return {
        ...state,
        agentDeleteData: {
          ...state.agentDeleteData,
          message: '',
        },
      };
    default:
      return state;
  }
};

export default AgentReducer;
